import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Alert, Button } from '@polichat/flamboyant';
import { toast } from 'react-toastify';

import history from '../../../../services/history';
import WabaService from '../../../../services/tools/template-waba/template-waba';

import { MessagesBuilderImg } from 'src/components/chat/content/chat/modals/src/MessagesBuilderImg.js';

import Animation from '../../../common/animation';
import TablePagination from '../../../shopping/TablePagination';

import PageMainBody from '../../../common/pages/PageMainBody/PageMainBody.component';
import PageMainHeader from '../../../common/pages/PageMainHeader/PageMainHeader.component';
import DeleteTemplateModal from './deleteModal/DeleteTemplateModal.component';
import {
  ButtonsContainer,
  Container,
  MessageBuilderHome,
  MessageBuilderLayout,
} from './ListMessagesBuilder.styles';
import SearchTemplateBar from './searchbar/SearchTemplateBar.component';
import TableMessagesBuilder from './table/TableMessagesBuilder.component';
import { useWhiteLabel } from 'src/hooks/useWhiteLabel';
import { FilterType } from './filtersList/filterType';
import { FilterStatus } from './filtersList/filterStatus';
import { useFlags } from 'flagsmith/react';
import { useGlotaT } from '../../../../hooks/useGlotaTranslation';

let handleOnSearchFilterChangeTimer;

const ListMessagesBuilder = () => {
  // Traduções
  const synchronizeTemplates = useGlotaT('spa.tools.synchronizeTemplates');
  const synchronizing = useGlotaT('spa.tools.synchronizing');
  const exploreTutorials = useGlotaT('spa.tools.exploreTutorials');
  const createMessage = useGlotaT('spa.tools.createMessage');
  const withMessageBuilder = useGlotaT('spa.tools.withMessageBuilder');
  const tryAgainMessage = useGlotaT('spa.tools.tryAgainMessage');
  const createMessageButton = useGlotaT('spa.tools.createMessageButton');
  const noRecordsFound = useGlotaT('spa.tools.noRecordsFound');
  const tagText = useGlotaT('spa.tools.tag');
  const typeText = useGlotaT('spa.tools.type');
  const categoryText = useGlotaT('spa.tools.category');
  const contentText = useGlotaT('spa.tools.content');
  const shortcutText = useGlotaT('spa.tools.shortcut');
  const statusText = useGlotaT('spa.tools.status');
  const messageBuilderTitle = useGlotaT('spa.messageBuilder.title');
  const quickMessageTitle = useGlotaT('spa.messageBuilder.quickMessage');
  const errorDeletingTemplate = useGlotaT('spa.messageBuilder.errorDeletingTemplate');
  const templateDeleted = useGlotaT('spa.messageBuilder.templateDeleted');
  const syncError = useGlotaT('spa.messageBuilder.syncError');
  const syncCompleted = useGlotaT('spa.messageBuilder.syncCompleted');
  
  const customerID = useSelector((state) => state.general.current_customer_id);
  const [messagesList, setMessagesList] = useState([]);
  const whitelabel = useWhiteLabel();
  const [searchData, setSearchData] = useState('');
  const [paginationData, setPaginationData] = useState({});
  const [isLoadingMessagesTemplate, setIsLoadingMessagesTemplate] =
    useState(false);
  const [hasFirstRequestData, setHasFirstRequestData] = useState(0);
  const [tryFetchDataAgain, setTryFetchDataAgain] = useState(false);

  const [isDeleteTemplateModalOpen, setIsDeleteTemplateModalOpen] =
    useState(false);
  const [templateDeleteData, setTemplateDeleteData] = useState({});
  const [buttonTemplateSyncState, setButtonTemplateSyncState] = useState({
    disabled: false,
    content: synchronizeTemplates,
    loading: '',
  });
  const [typeValue, setTypeValue] = useState('all');
  const [statusValue, setStatusValue] = useState('all');
  const [disabledFilterStatus, setDisabledFilterStatus] = useState(true)
  const flag = useFlags(['filter_by_type']);

  const filterIsTemplate = {
    template: {
      is_template: 1,
    },
    quick_message: {
      is_template: 0,
    }
  }

  const filterValidated = {
    approved: {
      validated: 1,
    },
    disapproved: {
      validated: 0,
    },
    waitingForApproval: {
      validated: 2,
    }
  }

  async function fetchTemplateList(fetchData) {
    setIsLoadingMessagesTemplate(true);
    const payload = {
      customer_id: customerID
    }
    const is_template = filterIsTemplate[fetchData?.type]?.is_template >= 0 ? filterIsTemplate[fetchData?.type]?.is_template : null;
    const validated = filterValidated[fetchData?.status]?.validated >= 0 ? filterValidated[fetchData?.status]?.validated : null;

    if (is_template !== null) {
      payload.is_template = is_template;
    }
    if (validated !== null) {
      payload.validated = validated;
    }
    if (fetchData?.currentPage) {
      payload.page = fetchData?.currentPage;
    }
    if (fetchData?.search) {
      payload.q = fetchData?.search;
    }
    if (fetchData?.type) {
      payload.type = fetchData?.type;
    }

    try {
      const { data, pagination } = await WabaService.getTemplatesWaba(payload);
      if (data || pagination) {
        setMessagesList(data);
        setPaginationData(pagination);
        setTryFetchDataAgain(false);
        setHasFirstRequestData((old) => old + 1);
      } else {
        setTryFetchDataAgain(true);
      }
    } catch (error) {
      console.log(
        'Error in ListMessagesBuilder component when fetchTemplates => ',
        error
      );
      setTryFetchDataAgain(true);
    }
    setIsLoadingMessagesTemplate(false);
  }

  async function syncTemplates() {
    // setIsLoadingMessagesTemplate(true);
    setButtonTemplateSyncState({
      disabled: true,
      content: (
        <span>
          <Animation
            icon="loading"
            style={{
              float: 'left',
              height: 20,
              width: 20,
              margin: '0 5px 0 0',
              borderColor: '#FFFFFF'
            }}
          />
          {synchronizing}
        </span>
      ),
      loading: '', // <Animation icon="chat-loading" />
    });
    try {
      const { data } = await WabaService.syncTemplates({
        customer_id: customerID,
      });
      if (!(data && data.error)) {
        toast.success(data?.message ?? syncCompleted);
      } else {
        toast.error(data?.message ?? syncError);
      }
    } catch (error) {
      toast.error(syncError);
      console.log(
        'Error in ListMessagesBuilder component when syncTemplates => ',
        error
      );
    }
    // setIsLoadingMessagesTemplate(false);
    setButtonTemplateSyncState({
      disabled: false,
      content: synchronizeTemplates,
      loading: '',
    });
    await fetchTemplateList();
  }

  useEffect(() => {
    fetchTemplateList();
  }, []);

  const handleSyncTemplates = () => {
    syncTemplates();
  };

  const goToTutorials = () => {
    window.open(
      'https://www.youtube.com/channel/UC6F-t3Qvgo2zMbEGICLQYIg',
      '_blank'
    );
  };
  const goToCreateTemplate = () => {
    history.push({
      pathname: '/tools/messages-builder/add',
    });
  };

  const handleChangePaginationRequest = (paginationData) => {
    const { currentPage } = paginationData;
    fetchTemplateList({ currentPage, type: typeValue, status: statusValue });
  };

  const handleChangeSearchRequest = (searchData) => {
    setSearchData(searchData?.search || '');

    clearTimeout(handleOnSearchFilterChangeTimer);
    handleOnSearchFilterChangeTimer = setTimeout(() => {
      fetchTemplateList(searchData);
    }, 600);
  };

  async function handleChangeTypeFilter(value) {
    if (value === 'template') {
      setDisabledFilterStatus(false)
      setTypeValue(value)
      fetchTemplateList({ type: value, status: statusValue })
    } else {
      setDisabledFilterStatus(true)
      setStatusValue('all')
      setTypeValue(value)
      fetchTemplateList({ type: value, status: 'all' })
    }
  }

  async function handleChangeStatusFilter(value) {
    setStatusValue(value)
    fetchTemplateList({ status: value, type: typeValue })
  }

  const handleOptionClicked = ({ id, option, template_name, tag }) => {
    if (option === 'delete') {
      setIsDeleteTemplateModalOpen(true);
      setTemplateDeleteData({ id, template_name, tag });
    }
    if (option === 'edit') {
      history.push({
        pathname: `/tools/messages-builder/edit/${id}`,
      });
    }
  };

  function handleCloseDeleteTemplateModal() {
    setIsDeleteTemplateModalOpen(false);
  }

  async function handleDeleteTemplate(id) {
    let params = { template_id: id, customer_id: customerID };

    const result = await WabaService.deleteTemplateWaba(params);
    if (result.error) {
      toast.error(errorDeletingTemplate);
    }
    if (result.success) {
      toast.success(templateDeleted);
      setMessagesList(messagesList.filter((item) => item.id !== id));
    }
  }

  const colsTitle = [
    { colID: 1, colTitle: tagText },
    { colID: 2, colTitle: typeText },
    { colID: 3, colTitle: categoryText },
    { colID: 4, colTitle: contentText },
    { colID: 5, colTitle: shortcutText },
    { colID: 6, colTitle: statusText },
    { colID: 7, colTitle: '' },
  ];
  return (
    <>
      <PageMainHeader
        title={whitelabel.isWl ? quickMessageTitle : messageBuilderTitle}
        icon="poli-icon pi-message-builder-fill"
      >
        {(messagesList && !whitelabel.isWl || (messagesList && whitelabel.spaTitle === 'NectarCRM')) && (
          <>
            {/* <Button gradient="primary" onClick={goToCreateTemplate}>
              Criar uma mensagem
            </Button> */}
            {buttonTemplateSyncState.loading}
            <Button
              disabled={buttonTemplateSyncState.disabled}
              gradient="primary"
              onClick={handleSyncTemplates}
            >
              {buttonTemplateSyncState.content}
            </Button>
            {!whitelabel.isWl && 
              <Button color="primary" outline onClick={goToTutorials}>
                {exploreTutorials}
              </Button>
            }
          </>
        )}
      </PageMainHeader>
      <PageMainBody>
        <Container>
          {!messagesList.length && hasFirstRequestData <= 1 ? (
            <MessageBuilderHome>
              <MessagesBuilderImg />
              <p>
                {createMessage}
              </p>

              {isLoadingMessagesTemplate ? (
                <Animation icon="loading" />
              ) : (
                <>
                  <p>
                    {withMessageBuilder}
                  </p>
                  <ButtonsContainer>
                    {tryFetchDataAgain ? (
                      <Button gradient="primary" onClick={fetchTemplateList}>
                        {tryAgainMessage}
                      </Button>
                    ) : (
                      <>
                        <Button gradient="primary" onClick={goToCreateTemplate}>
                          {createMessageButton}
                        </Button>
                      </>
                    )}
                  </ButtonsContainer>
                </>
              )}
            </MessageBuilderHome>
          ) : (
            <MessageBuilderLayout>
              <div className="header">
                {flag.filter_by_type?.enabled && (
                  <>
                    <FilterType
                      handleChangeTypeFilter={(event) => handleChangeTypeFilter(event.target.value)}
                      typeValue={typeValue}
                    />
                    <FilterStatus
                      disabled={disabledFilterStatus}
                      handleChangeStatusFilter={(event) => handleChangeStatusFilter(event.target.value)}
                      statusValue={statusValue}
                    />
                  </>
                )}
                <SearchTemplateBar
                  onSearchChange={handleChangeSearchRequest}
                  initialValue={searchData}
                />
              </div>
              <div className="body">
                {messagesList.length ? (
                  <TableMessagesBuilder
                    cols={colsTitle}
                    rows={messagesList}
                    isLoading={isLoadingMessagesTemplate}
                    onOptionsClick={handleOptionClicked}
                  />
                ) : (
                  <Alert color="attention">
                    {noRecordsFound}
                  </Alert>
                )}
              </div>
              <div className="footer">
                <TablePagination
                  totalItens={paginationData.totalRegisters}
                  limitItens={paginationData.registersPerPage}
                  pageSide={paginationData.currentPage}
                  onPageChange={handleChangePaginationRequest}
                />
              </div>
            </MessageBuilderLayout>
          )}
        </Container>
      </PageMainBody>
      <DeleteTemplateModal
        isOpen={isDeleteTemplateModalOpen}
        onCloseRequest={handleCloseDeleteTemplateModal}
        data={templateDeleteData}
        onDeleteRequest={handleDeleteTemplate}
      />
    </>
  );
};

export default ListMessagesBuilder;
